/*
 * @Author: 李才人
 * @Date: 2021-07-30 16:31:24
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-03 09:53:02
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\api\questionnaire.ts
 * @Description:
 */

import { RequestConfig } from "@/utils/httpUtil/interface/RequestConfig";
// import { post, postExFile, getExFile } from "@utils/httpUtil";
import { post, postForm } from "@utils/httpUtil";

/**
 *
 * $ 获取问卷详情
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<TaskAllData>}
 */
export interface questionnaireParams {
  id: number | string;
}

export const getQuestionnaireDetail = (data: questionnaireParams, config?: RequestConfig) => {
  return postForm(`/questionnaire/getDetailById`, data, config ? config : { originalData: false });
};
export interface IQuestionData {
  communityId: string;
  cover?: string;
  creatorId?: string;
  exitPopup: string;
  id?: string;
  itemList: Array<any>;
  popupText: string;
  remark: string;
  status?: number | string;
  submitItemList: Array<any>;
  submitText: string;
  submitTitle: string;
  subtitle: string;
  title: string;
  titleHide: string | number;
  userAuth?: string;
}

/**
 *
 * $ 保存问卷草稿
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveQuestionnaireDraft(data: IQuestionData, config?: RequestConfig): Promise<boolean> {
  return post(`/questionnaire/saveDraft`, data, config);
}

/**
 *
 * 保存问卷
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveQuestionnaire(data: IQuestionData, config?: RequestConfig): Promise<boolean> {
  return post(`/questionnaire/saveQuestionnaire`, data, config);
}

/**
 *
 * $ 根据社区id获取问卷草稿
 * @export
 * @param {{ communityId: string }} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<IQuestionData>}
 */
export function getQuestionnaireDraftByCommtyId(data: { communityId: string; questionnaireType: string; questionnaireSource: string }, config?: RequestConfig): Promise<IQuestionData> {
  return post(`/questionnaire/getDraft`, data);
}
/**
 *
 * $ 获取积分列表
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<TaskAllData>}
 */
export interface TaskItem {
  des: string;
  event: string;
  ico: string;
  id: number;
  rewardType: number;
  sortNo: number;
  style: number;
  title: string;
  type: number;
  url: string;
}
export type TaskAllData = Array<TaskItem>;
export const getAllTask = (config?: RequestConfig): Promise<TaskAllData> => {
  return post(`/community/user/task/getAllTask`, config ? config : { originalData: false });
};
/**
 *
 * $ 保存/更新社区规则
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<TaskAllData>}
 */

export interface SaveRuleParams {
  communityId: number;
  configVOList: ConfigVOList[];
}

export interface ConfigVOList {
  dailyTimes: number;
  reward: string;
  rewardType: number;
  status: number;
  taskId: number;
}
export const saveCommunityTaskConfig = (data: SaveRuleParams, config?: RequestConfig) => {
  return post(`/community/user/task/saveCommunityTaskConfig`, data, config ? config : { originalData: false });
};

/**
 * 校验问卷标题是否重复
 * @param data
 * @param config
 * @returns
 */

export interface checkRepeat {
  // communityId?: string;
  id?: string;
  questionnaireSource?: string;
  questionnaireType?: string;
  title: string;
  [key: string]: any;
}
export const checkQuestionnaireTitleUnique = (data: checkRepeat, config?: RequestConfig) => {
  return post(`/questionnaire/checkQuestionnaireTitleUnique`, data, config ? config : { originalData: false });
};

/**
 * 查询分类列表
 * @param  data
 * @param RequestConfig
 * @returns
 */

export enum EnumBusinessType {
  QUESTIONNAIRE = "QUESTIONNAIRE", // 问卷
  ANSWER = "ANSWER", // 答题
}

export enum EnumCommunityType {
  DOCTOR = "DOCTOR", // 医生社区
  PATIENT = "PATIENT", // 健康社区
}
export interface ICatalog {
  businessType: EnumBusinessType;
  communityType: EnumCommunityType;
  name?: string;
  catalogId?: number | null;
  question?: string;
  includeIds?: any[];
  num?: number;
  pageSize?: number;
  pageNum?: number;
}

export const getCatalog = (data: ICatalog, config?: RequestConfig) => {
  return post(`/baseQuestionnaire/getCatalog`, data, config ? config : { originalData: false });
};

/**
 * 分页查询题目
 * @param ICatalog
 * @param RequestConfig
 * @returns
 */

export const baseQuestionnaireGetPage = (data: ICatalog, config?: RequestConfig) => {
  return post(`/baseQuestionnaire/getPageRelation`, data, config ? config : { originalData: false });
};

/**
 * 获取随机题目
 * @param ICatalog
 * @param RequestConfig
 * @returns
 */

export const getRandomItems = (data: ICatalog, config?: RequestConfig) => {
  return post(`/baseQuestionnaire/getRandomItems`, data, config ? config : { originalData: false });
};

export const getCatalogSummary = (data: ICatalog, config?: RequestConfig) => {
  return post(`/baseQuestionnaire/catalog/getCatalogSummary`, data, config ? config : { originalData: false });
};

export const getAllIds = (data: ICatalog, config?: RequestConfig) => {
  return post(`/baseQuestionnaire/getAllIds`, data, config ? config : { originalData: false });
};

export function checkItemExist(data: IQuestionData, config?: RequestConfig): Promise<boolean> {
  return post(`/questionnaire/checkItemExist`, data, config);
}

/**
 *
 * 保存问卷模板
 *
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function formtemplateSave(data: IQuestionData, config?: RequestConfig): Promise<boolean> {
  return post(`/formtemplate/save`, data, config);
}
/**
 *
 * 保存问卷模板并且生成表单
 *
 * @export
 * @param {IQuestionData} data
 * @param {RequestConfig} [config]
 * @return {*}  {Promise<boolean>}
 */
export function saveAndGenerateQuestionnaire(data: IQuestionData, config?: RequestConfig): Promise<boolean> {
  return post(`/formtemplate/saveAndGenerateQuestionnaire`, data, config);
}

export interface formtemplateGetDetailParams {
  id: number | string;
  copy?: boolean;
}

export const formtemplateGetDetail = (data: formtemplateGetDetailParams, config?: RequestConfig) => {
  return post(`/formtemplate/getDetail`, data, config ? config : { originalData: false });
};

export interface formtemplateGenerateQuestionnaireParams {
  templateId: number | string;
}

export const formtemplateGenerateQuestionnaire = (data: formtemplateGenerateQuestionnaireParams, config?: RequestConfig) => {
  return post(`/formtemplate/generateQuestionnaire`, data, config ? config : { originalData: false });
};

export interface formtemplateCheckTitleUniqueParams {
  id: number | string;
  title: number | string;
  questionnaireSource: string;
  questionnaireProperty: string;
  questionnaireType: string;
}

export const formtemplateCheckTitleUnique = (data: formtemplateCheckTitleUniqueParams, config?: RequestConfig) => {
  return post(`/formtemplate/checkTitleUnique`, data, config ? config : { originalData: false });
};
